import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { UnauthorizedPageComponent } from '@shared/components/unauthorized-page/unauthorized-page.component';
import { ErrorPageComponent } from '@shared/components/error-page/error-page.component';
import { FooterComponent } from '@layout/components/footer/footer.component';
import { SidebarComponent } from '@layout/components/sidebar/sidebar.component';
import { HeaderComponent } from '@layout/components/header/header.component';
import { MobileMenuComponent } from '@layout/components/mobile-menu/mobile-menu.component';
import { BreadcrumbsComponent } from '@layout/components/breadcrumbs.component';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule,
        TranslateModule,
        ToastModule,
        LoaderComponent,
        UnauthorizedPageComponent,
        ErrorPageComponent,
        FooterComponent,
        SidebarComponent,
        HeaderComponent,
        MobileMenuComponent,
        BreadcrumbsComponent,
    ],
    providers: [MessageService],
    bootstrap: [AppComponent],
})
export class AppModule {}
